import { Table } from "../table";
import { CheckColumn } from "./CheckColumn";
import { ColumnDefinition } from "./ColumnDefinitions";
import { ComponentColumn, ComponentColumnDefinition } from "./ComponentColumn";
import { DateColumDefinition, DateColumn } from "./DateColumn";
import { IconColumn } from "./IconColumn";
import { NumberColumn } from "./NumberColumn";
import { TextColumn } from "./TextColumn";

export class ColumnFactory {
    public static column(
        columnNumber: number,
        definition: ColumnDefinition,
        table: Table): DataTables.ColumnDefsSettings {
        const type = definition.type ?? "TextColumn";
        if (type === "CheckColumn") {
            table.status.initCheckedProperty(definition.property);
            return new CheckColumn(
                columnNumber,
                definition,
                table.rowKey,
                table.status,
                table.restrictions);
        } else if (type === "IconColumn") {
            return new IconColumn(columnNumber, definition, table);
        } else if (type === "NumberColumn") {
            return new NumberColumn(columnNumber, definition);
        } else if (type === "DateColumn") {
            return new DateColumn(columnNumber, definition as DateColumDefinition);
        } else if (type === "ComponentColumn") {
            return new ComponentColumn(columnNumber, definition as ComponentColumnDefinition, table);
        } else {
            return new TextColumn(columnNumber, definition, table);
        }
    }
}
